import React, { Component } from "react"
import { split, concat, flatMap, uniqueId } from "lodash"
import fetch from "cross-fetch"
import InfiniteScroll from "react-infinite-scroller"

import SearchFilter from "../search-filter"
import SearchBar from "../search-bar"
import UserCard from "../user-card"
import Loader from "../loader"

function buildSearchQuery(search) {
  const searchWords = split(search, " ")
  return `${searchWords.join("* | ")}*`
}

class FacultySearch extends Component {
  filters = [
    {
      style: "tags",
      title: "Programs",
      field: "PublishBio",
      options: [
        "Postgraduate",
        "Ashridge Executive Education",
        "Undergraduate",
      ],
    },
  ]

  page = 0
  size = 10

  constructor(props) {
    super(props)

    this.search = this.search.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.onFilterChange = this.onFilterChange.bind(this)

    this.state = {
      loading: true,
      faculty: [],
      search: "",
      filters: [],
      offset: 0,
      total: 0,
    }
  }

  search() {
    this.page += 1
    const { search, filters, offset, faculty } = this.state
    fetch(`${process.env.GATSBY_HULTEDUDATA_API}/faculty/search`, {
      method: "POST",
      body: JSON.stringify({
        from: offset,
        size: this.size,
        search: buildSearchQuery(search),
        filters,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(res => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then(result => {
        this.setState({
          faculty: concat(
            faculty,
            flatMap(result.hits.hits, f => f._source)
          ),
          loading: false,
          total: result.hits.total,
          offset: this.page * this.size,
        })
      })
      .catch(err => {
        console.error(err)
      })
  }

  onSearchChange(searchValue) {
    this.page = 0
    this.setState({
      search: searchValue,
      faculty: [],
      offset: 0,
      total: 0,
      loading: true,
    })
  }

  onFilterChange(filters) {
    this.page = 0
    this.setState({
      filters,
      faculty: [],
      offset: 0,
      total: 0,
      loading: true,
    })
  }

  render() {
    const { loading, faculty, offset, total } = this.state

    return (
      <div className="grid grid--gutters-sm grid--v-top">
        <div className="grid__col grid__col--1-4">
          <SearchFilter
            filterGroups={this.filters}
            onChange={this.onFilterChange}
          />
        </div>
        <div className="grid__col grid__col--3-4">
          <div className="grid grid--gutters-md grid--v-top">
            <div className="grid__col grid__col--1-1">
              <SearchBar
                resultCount={faculty.length}
                totalCount={total}
                placeholder={"Search for a faculty member..."}
                onSearchChange={this.onSearchChange}
              />
            </div>
          </div>

          <div className="grid grid--gutters-md grid--v-top">
            <div className="grid__col grid__col--1-1">
              <InfiniteScroll
                pageStart={0}
                loadMore={this.search}
                hasMore={loading || offset < total}
                loader={<Loader key={0} />}
                className="search-results grid grid--gutters-xsm"
                threshold={500}
              >
                <>
                  {faculty.map(f => (
                    <div
                      key={uniqueId(f.Id)}
                      className="grid__col grid__col--1-2 grid__col--lg-1-1"
                    >
                      <a href={`/faculty/profile/?cid=${f.Id}`}>
                        <UserCard
                          avatarUrl={f.image}
                          name={`${f.FirstName} ${f.LastName}`}
                          location={f.Campus}
                          programs={f.PublishBio}
                        />
                      </a>
                    </div>
                  ))}
                </>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FacultySearch
